<form [formGroup]="roleForm">
    <div class="col-sm-10 controls-input">
        <div class="gap"></div>
        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
            <!-- <div class="mdc-text-field__ripple"></div> -->
            <input id="name" class="mdc-text-field__input  input-aligner txt-spacer" type="text" maxlength="256"
                matInput (paste)="on_paste_omit_special_char($event,'name')" (keypress)="omit_special_char($event)"
                formControlName="name" required aria-label="name" aria-labelledby="my-label-name"
                aria-controls="my-helper-id" aria-describedby="my-helper-id">
            <span class="mdc-floating-label  minus-margin" id="my-label-name">Name</span>
            <div class="mdc-line-ripple"></div>
        </label>
        <div class="mdc-text-field-helper-line"></div>
    </div>

    <div class="col-sm-10 controls-input">
        <div class="gap"></div>
        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
            <input  id="description" class="mdc-text-field__input  input-aligner txt-spacer" type="text" maxlength="1000"
                matInput (paste)="on_paste_omit_special_char($event,'description')" (keypress)="omit_special_char($event)"
                formControlName="description" required aria-label="description" aria-labelledby="my-label-id"
                aria-controls="my-helper-id" aria-describedby="my-helper-id">
            <span class="mdc-floating-label  minus-margin" id="my-label-id">Description</span>
            <div class="mdc-line-ripple"></div>
        </label>
        <div class="mdc-text-field-helper-line"></div>
    </div>

    <div class="col-sm-12 m-b-10 p-l-5">
        <div class="mdc-form-field formfield-material">
            <div class="mdc-checkbox">
                
                <div class="col-sm-12 pull-left" (click)="isActive = !isActive; onCheckChange(isActive)" (keydown)="noop()">
                    <span *ngIf="isActive" class="checkbox-item-font ey-dna-icon-Selected_Checkbox"></span>
                    <span *ngIf="!isActive" class="checkbox-item-font ey-dna-icon-Unselected_Checkbox"></span>
                </div>
            </div>
            <label style="padding-top: 5px; padding-left: 0px;" for="checkbox-1">Active</label>
        </div>
    </div>

    <div class="col-sm-12 m-b-10 fids-o-p-l controls-input">
        <app-treeview title="Features">
            <ng-template #customTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
                let-onCheckedChange="onCheckedChange">
                <div class="form-inline row-item">
                    <i *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" class="fa"
                        [class.fa-plus]="item.collapsed" [class.fa-minus]="!item.collapsed" (keydown)="noop()"></i>
                    <div class="form-check">
                        <input type="checkbox" style="visibility:visible; width:0px;" class="form-check-input"
                            value="item.checked" (ngModelChange)="onCheckedChange()"
                            [indeterminate]="item.indeterminate" 
                             [disabled]="item.disabled ? true : false"/> 
                        <div class="col-sm-12 pull-left" 
                             [class.disabled-permission]="item.disabled"
                        (click)="item.checked = !item.checked;onCheckedChange(); onCheckedChangePopup(item)" (keydown)="noop()" >
                            <span *ngIf="item.checked==true"
                                class="tree-item-font ey-dna-icon-Selected_Checkbox"></span>
                            <span *ngIf="item.checked==false"
                                class="tree-item-font ey-dna-icon-Unselected_Checkbox"></span>
                            <span *ngIf="item.indeterminate" class="tree-item-font ey-dna-icon-Checkbox_Half"></span>
                            <span *ngIf="item.disabled"      class="tree-item-font ey-dna-icon-Disabled_Checkbox"></span>
                            <span class="form-check-label">{{item.text}}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #headerTemplate let-config="config" let-item="item" let-onCollapseExpand="onCollapseExpand"
                let-onCheckedChange="onCheckedChange" let-onFilterTextChange="onFilterTextChange"
                class="controls-input">
                <div *ngIf="config.hasFilter" class="row row-filter">
                    <div class="col-sm-12 controls-input">
                        <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material mb-0">
                            <!-- <div class="mdc-text-field__ripple"></div> -->
                            <input class="mdc-text-field__input  input-aligner txt-spacer" aria-label="name"
                                aria-labelledby="my-label-id" aria-controls="my-helper-id"
                                aria-describedby="my-helper-id" type="text" [(ngModel)]="filterText"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="onFilterTextChange($event)" />
                            <span class="mdc-floating-label  minus-margin" id="my-label-id">Search</span>
                            <div class="mdc-line-ripple"></div>
                        </label>
                        <div class="mdc-text-field-helper-line">
                        </div>
                    </div>
                </div>
                <div *ngIf="config.hasAllCheckBox || config.hasCollapseExpand && hasAllVisibility" class="row">
                    <input type="checkbox" style="visibility:visible; width:0px;" class="form-check-input"
                        [(ngModel)]="item.checked" [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="onCheckedChange()" [indeterminate]="item.indeterminate" (keydown)="noop()"
                        [disabled]="item.disabled == true ? true : false"/>
                    <div class="col-sm-12 tree-item-header" (click)="item.checked = !item.checked; onCheckedChange(); onCheckedChangePopup(item)" (keydown)="noop()">
                        <span *ngIf="item.checked==false" class="tree-item-font ey-dna-icon-Unselected_Checkbox"></span>
                        <span *ngIf="item.indeterminate" class="tree-item-font ey-dna-icon-Checkbox_Half"></span>
                        <span *ngIf="item.disabled"      class="tree-item-font ey-dna-icon-Disabled_Checkbox"></span>                      
                        <span *ngIf="item.checked==true" class="tree-item-font ey-dna-icon-Selected_Checkbox"></span>
                        <span class="form-check-label">{{item.text}}</span>
                    </div>
                </div>
                <div *ngIf="config.hasDivider" class="dropdown-divider"></div>
            </ng-template>
            <ngx-treeview [config]="config" [items]="items" [headerTemplate]="headerTemplate"
                [itemTemplate]="customTemplate" (filterChange)="onFilterChange($event)"
                (selectedChange)="selectPermissionItem($event)">
            </ngx-treeview>
        </app-treeview>
    </div>


    <div class="col-sm-12 m-b-10">
        <div class="row m-r-0 m-l-0">
            <div class="col pl-0">
                <button class="mdc-button ripple-material" mat-stroked-button (click)="close()" type="button">
                    <span class="mdc-button__ripple"></span> Cancel
                </button>
                <button class="mdc-button ml-3 fids-tooltip mdc-button--raised mdc-button--sharp ripple-material"
                mat-stroked-button [disabled]="!roleForm.valid" 
                    (click)="save()" type="submit" #submitButton>
                    <span class="mdc-button__ripple"></span> Submit
                </button>
            </div>
        </div>
    </div>
</form>
